import { Tag, AutoComplete, Space } from "antd";
import { useState, useEffect, useRef, useMemo } from "react";
import DetailTitle from "@/components/DetailTitle";
import { TweenOneGroup } from "rc-tween-one";
import { PlusOutlined } from "@ant-design/icons";
import intl from "react-intl-universal";
import { useSelector } from "react-redux";
const NewTag = ({ tagUuids, setTagUuids, title, searchData = [], color, quikTagList = [] }) => {
  const tagSource = useMemo(() => {
    return quikTagList.map((item) => {
      return {
        label: item.label,
        value: item.value,
        color: tagUuids.includes(item.value) ? color : "",
      };
    });
  }, [tagUuids, quikTagList]);
  const [inputVisible, setInputVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const inputRef = useRef(null);
  const { userInfo } = useSelector((state) => state.user);
  const nickname = useMemo(() => userInfo?.nickname, [userInfo]);
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  const handleClose = (removedTag) => {
    const newTags = tagUuids.filter((tag) => tag !== removedTag);
    setTagUuids(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  useEffect(() => {
    if (searchData.length > 0) {
      const data = searchData.map((item) => {
        return { label: item.label, value: item.value };
      });
      setOptions(data);
    }
  }, [searchData]);
  const handleInputConfirm = (value) => {
    if (value && tagUuids.indexOf(value) === -1) {
      setTagUuids([...tagUuids, value]);
    }
    setInputVisible(false);
  };

  const getPanelValue = (text) => {
    if (text) {
      const result = searchData.filter((item) => item.value.includes(text));
      return result;
    } else {
      return options;
    }
  };

  const chooseTag = (value) => {
    if (tagUuids.indexOf(value) === -1) {
      setTagUuids([...tagUuids, value]);
    } else {
      setTagUuids(tagUuids.filter((item) => item !== value))
    }
  }
  return (
    <div style={{ marginBottom: "50px" }}>
      <DetailTitle title={title} isrequire={title === "Tag"} />
      <div
        style={{
          marginBottom: 16,
        }}
      >
        <TweenOneGroup
          appear={false}
          enter={{
            scale: 0.8,
            opacity: 0,
            type: "from",
            duration: 100,
          }}
          leave={{
            opacity: 0,
            width: 0,
            scale: 0,
            duration: 200,
          }}
          onEnd={(e) => {
            if (e.type === "appear" || e.type === "enter") {
              e.target.style = "display: inline-block";
            }
          }}
        >
          <Space size={[8, 16]} wrap={true}>
            {tagUuids.map((tag) => {
              return (
                <Tag
                  variant="outlined"
                  color={color}
                  closable
                  key={tag}
                  onClose={(e) => {
                    e.preventDefault();
                    handleClose(tag);
                  }}
                >
                  {tag}
                </Tag>
              );
            })}
          </Space>
        </TweenOneGroup>
      </div>
      {inputVisible ? (
        <AutoComplete
          options={options}
          style={{ width: "100%" }}
          ref={inputRef}
          allowClear
          onSelect={(data) => {
            handleInputConfirm(data)
          }}
          showSearch={{ onSearch: text => setOptions(getPanelValue(text)) }}
          onBlur={(e) => handleInputConfirm(e.target.value)}
          onInputKeyDown={(e) => {
            if (e.key === "Enter") {
              handleInputConfirm(e.target.value)
            }
          }}
          placeholder="Press Entet"
        />
      ) : (

        <Tag onClick={showInput}>
          <PlusOutlined />
          &nbsp;&nbsp;{intl.get(`Share.New ${title}`)}
        </Tag>
      )}
      <div>
        <Space size={[8, 8]} wrap={true} style={{ marginTop: 15 }}>
          {
            tagSource.map(item => {
              return <Tag style={{ cursor: "pointer" }} onClick={() => chooseTag(item.value)} variant="outlined" color={item.color} key={item.value + ""}>{item.label}</Tag>
            })
          }
        </Space>
      </div>
      {title === "Authors & Contributor" && (
        <h4>
          {intl.get("Share.Contributor")}
          <span>{nickname}</span>
        </h4>
      )}
    </div>
  );
};
export default NewTag;
